/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Electrical_Engineering26Inputs */

const en__field_enum_icsrm_electrical_engineering26 = /** @type {(inputs: _Field_Enum_Icsrm_Electrical_Engineering26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrical Engineering`)
};

const de__field_enum_icsrm_electrical_engineering26 = /** @type {(inputs: _Field_Enum_Icsrm_Electrical_Engineering26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektrotechnik`)
};

/**
* | output |
* | --- |
* | "Electrical Engineering" |
*
* @param {_Field_Enum_Icsrm_Electrical_Engineering26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_electrical_engineering26 = /** @type {((inputs?: _Field_Enum_Icsrm_Electrical_Engineering26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Electrical_Engineering26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_electrical_engineering26(inputs)
	return de__field_enum_icsrm_electrical_engineering26(inputs)
});
export { _field_enum_icsrm_electrical_engineering26 as "_field_enum_ICSRM_ELECTRICAL_ENGINEERING" }